<template>
    <div class="row">
        <div class="col-12">
            <div class="panel-sub-heading headingLarge" v-if="!is_reviewing">
                <span class="h5 display-6 markedBottom bold">{{ lang('generated_documents') }}</span>
            </div>
        </div>
        <div class="col-12" >
            <div class="row" v-if="generated_documents.length > 0">
                <div class="col-12">
                    <div class="panel-sub-heading">
                        <span class="h5 display-6 markedBottom bold">{{ lang('agreement_documents') }}</span>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="row">

                                <!--                                    <div class="col-lg-6 col-md-6 col-12"-->
                                <!--                                    >-->
                                <!--                                        <div class="list-group" >-->
                                <!--                                            <a target="__blank"  v-for="(generated_document, generated_document_index) in generated_documents"  @click="setModalData(generated_document)">-->
                                <!--                                                <li class="list-group-item d-flex justify-content-between align-items-center">-->
                                <!--                                                    <span>{{generated_document.document_type.document_name}}</span>-->
                                <!--                                                    <span class="float-right float-end"><i class="fa fa-download"></i></span>-->
                                <!--                                                </li>-->
                                <!--                                            </a>-->
                                <!--                                        </div>-->
                                <!--                                    </div>-->

                                <div class="col-lg-4 col-md-6 col-12" v-for="(generated_document, generated_document_index) in generated_documents">
                                    <div class="card paddingBottom20">
                                        <div class="card-header">
                                            <div class="row">
                                                <div class="col-12">
                                                    <span @click="setModalData(generated_document)" class="document-name">{{generated_document.document_type.document_name}}</span>
                                                    <span class="float-right float-end"><a target="__blank" :href="`/application/viewdocument/${merchant.application_external_id}/${generated_document['document_external_id']}`"> <i class="fa fa-download"></i></a></span>
                                                </div>
                                            </div>
                                        </div>
                                        <!--                                                <div class="card-body">-->
                                        <!--                                                    <div class="col-12 p-0">-->
                                        <!--                                                        <div class="row">-->
                                        <!--                                                            <div class="col-12">-->
                                        <!--                                                               <a target="__blank" :href="`/application/viewdocument/${merchant.application_external_id}/${generated_document['document_external_id']}`"> {{generated_document.document_type.document_key}} </a>-->
                                        <!--                                                            </div>-->
                                        <!--                                                        </div>-->
                                        <!--                                                    </div>-->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12" v-if="noDocumentGenerated">
            <np-notice :notice="lang('no_generated_documents')"></np-notice>
        </div>

        <np-pdf-modal :url="currentUrl" :title="pdfModalTitle"  id="elavon-pdf"></np-pdf-modal>

    </div>
</template>

<script>
    import utilMixin from "../../../utils/mixins";
    import applicationMixin from "../../../utils/application-mixin";
    import {
        NPCheckBox,
        NPCompanySearch,
        NPDatePicker, NPEntry,
        NPInput, NPNotice,
        NPModal, NPPhone, NPPostcodeSearch,
        NPRadios, NPResponsive,
        NPSelect2, NPSkeleton, NPPdfModal,
        NPTextArea, NPVat, NPDocumentUploadWidget, NPUpload
    } from "netpify/components";
    import {Document} from '../../../entities';
    import VueUploadComponent from 'vue-upload-component';


    const DOCUMENT_ENTITY_CODE_PRINCIPAL = 'PRINCIPAL';
    const DOCUMENT_ENTITY_CODE_BUSINESS = 'BUSINESS';
    const DOCUMENT_ENTITY_CODE_OUTLET = 'OUTLET';
    const DOCUMENT_ENTITY_CODE_BUSINESS_CONTACT = 'BUSINESS_CONTACT';
    const DOCUMENT_ENTITY_CODE_OUTLET_CONTACT = 'OUTLET_CONTACT';
    const DOCUMENT_ENTITY_CODE_BUSINESS_BANK = 'BUSINESS_BANK';
    const DOCUMENT_ENTITY_CODE_OUTLET_BANK = 'OUTLET_BANK';


    export default {
        name: "viewGeneratedDocument",
        mixins: [utilMixin, applicationMixin],
        components: {
            'file-upload': VueUploadComponent,
            'np-upload-widget': NPDocumentUploadWidget,
            'np-modal': NPModal,
            'np-textarea': NPTextArea,
            'np-radios': NPRadios,
            'np-input': NPInput,
            'np-checkbox': NPCheckBox,
            'np-date-picker': NPDatePicker,
            'np-select2': NPSelect2,
            'np-company-search': NPCompanySearch,
            'np-postcode-search': NPPostcodeSearch,
            'np-responsive': NPResponsive,
            'np-vat': NPVat,
            'np-phone': NPPhone,
            'np-skeleton': NPSkeleton,
            'np-upload': NPUpload,
            'np-notice': NPNotice,
            'np-entry': NPEntry,
            'np-pdf-modal': NPPdfModal,
        },
        data() {
            return {
                document: new Document(),
                currentUrl: '',
                pdfModalTitle: '',
                files: [],
                documents: [],
                generated_documents: [],
                document_categories: [],
                document_entities: [],
                signed_reference: '12345676543',
                page_label: 'generated_documents',
                signed_label: 'generated_documents'
            }
        },
        metaInfo() {
            return {
                title: this.lang('generated_documents')
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.setAppPageTitle(vm.page_label)

                if (!vm.isConvertedQuote){ //close this route when quote hasn't been converted
                    vm.$router.push({ path: `${vm.application_root_path}business/`})
                }
            })
        },
        props: {
            is_reviewing: {
                default: false,
                type: Boolean,
            }
        },
        computed: {
            tenantUploadCategories: function () {
                let params = this.parameters.hasOwnProperty('TENANT_UPLOAD_DOCUMENT_CATEGORY_PARAM') ?
                    this.parameters.TENANT_UPLOAD_DOCUMENT_CATEGORY_PARAM : [];
                return params.map(obj => new Document(obj))
            },
            isUploading: function () {
                if (!!this.$refs[`uploader_${document.id}`]) {
                    this.$refs[`uploader_${document.id}`].uploadStatus();
                }
                return false;
            },
            noDocumentGenerated: function () {
                return this.generated_documents.length === 0;
            }
        },
        methods: {
            setModalData: function (generated_document) {
                let vm = this;
                vm.pdfModalTitle = generated_document.document_type.document_name;
                vm.currentUrl = `/application/viewdocument/${vm.merchant.application_external_id}/${generated_document['document_external_id']}`;
                $('#elavon-pdf').modal({
                    backdrop: 'static',
                    keyboard: false
                });
            },
            formatSize: function (data) {
                return this.convertToDecimal(parseInt(data) / 1000000) + 'mb';
            },
            getEntityList: function (entity_id) {
                const params = this.parameters.hasOwnProperty('DOCUMENT_ENTITIES_PARAM') ?
                    this.parameters.DOCUMENT_ENTITIES_PARAM : [];

                const entity_meta_data = params.find(meta_data => meta_data.id == entity_id);
                if (entity_meta_data.entity_code === DOCUMENT_ENTITY_CODE_PRINCIPAL) {
                    this.merchant.owners = !!this.merchant.owners ? this.merchant.owners : [];
                    const owner_lists = this.merchant.owners.reduce((owner_lists, owner) => {
                        owner_lists.push({
                            id: owner.owner_ref,
                            text: `${owner.owner_title} ${owner.owner_first_name} ${owner.owner_surname}`
                        });
                        return owner_lists;
                    }, []);
                    return owner_lists;
                } else if (entity_meta_data.entity_code === DOCUMENT_ENTITY_CODE_BUSINESS) {
                    return [{
                        id: this.merchant._id,
                        text: this.merchant.legal_name
                    }];
                }  else if (entity_meta_data.entity_code === DOCUMENT_ENTITY_CODE_BUSINESS_CONTACT) {
                    const business_address = this.merchant.registration_address;
                    return [{
                        id: this.merchant.registration_address.contact_ref,
                        text: `${business_address.street_line_1} ${business_address.zip_code}`
                    }];
                } else if (entity_meta_data.entity_code === DOCUMENT_ENTITY_CODE_BUSINESS_BANK) {
                    this.merchant.banks = !!this.merchant.banks ? this.merchant.banks : [];
                    const bank_lists = this.merchant.banks.reduce((bank_lists, bank) => {
                        //console.log(bank);
                        bank_lists.push({
                            id: bank.bank_id,
                            text: `${bank.account_holder_name} - ${bank.bank_account_number_masked}`
                        });
                        return bank_lists;
                    }, []);
                    return bank_lists;
                }

                return [];
            },
            removeFile: function (file, ref = 0) {
                file.splice(ref);
                // this.$refs.upload[ref].remove(file);
            },
            formatUploadDocumentCategory: function (data) {
                return this.formatSelectType(this.parameters, data, 'UPLOAD_DOCUMENT_CATEGORY_PARAM')
            },
            formatUploadDocumentType: function (data) {
                return this.formatSelectType(this.parameters, data, 'TENANT_UPLOAD_DOCUMENT_TYPE_PARAM')
            },
            submitPrevent: function (){

            },
            getDocumentCategoryName: function (id) {
                let param = this.parameters.UPLOAD_DOCUMENT_CATEGORY_PARAM.find(obj => {
                    return obj.document_category_external_id === id
                });

                return !!param.category_name ? param.category_name : '';
            },
            uploadDocument: function () {
                let url = '/application/ajaxsubmitdocuments';
                let data = {
                    "application_external_id": this.merchant.application_external_id,
                    'documents': this.cleaqnDocumentData()
                };
                let vm = this;
                this.getAxiosInstance().post(url, data).then(response => {
                    if (response.data.result === 'SUCCESS') {
                        this.notifySuccess(this.lang("documents_uploaded_successfully"));
                    }
                });

            },
            /*
            Reduce Payload by removing unwanted data such as file Object which has been uploaded already
             */
            cleanDocumentData: function () {
                let documents = [];
                let vm = this;
                this.documents.forEach(document => {
                    let uploaded_files = [];
                    let clonedDoc = vm.jsonCopy(document);
                    clonedDoc.uploaded_files.forEach((file) => {
                        uploaded_files.push({
                            success: file.success,
                            file_name: file.file_name,
                            file_size: file.size,
                        });
                    });

                    clonedDoc.uploaded_files = uploaded_files;
                    documents.push(clonedDoc);
                });

                return documents;
            },
            getPrettyName: function (file_name) {
                return file_name.replace(/[_-]/g, " ");
            },
            homeRoute: function () {
                this.$router.push({path: `/`});
            },
            backPage: function () {
                this.$router.push({path: `${this.application_root_path}business_details/principals/`});
            },
            nextPage: function () {
                this.$router.push({path: `${this.application_root_path}review`});
            },
        },
        watch: {
            'merchant.documents': {
                immediate: true,
                handler: function(val) {
                    let vm = this;
                    let excluded_documents_by_key = ['APPLICATION_ADDENDUM'];
                    if (!!val) {
                        vm.generated_documents = val.filter(doc => {
                            return !!doc.is_generated && doc.is_generated === true
                                && doc.document_type
                                && doc.document_type.document_key
                                && !excluded_documents_by_key.includes(doc.document_type.document_key)
                        })
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>
